export enum Permissions {
  // Agency user roles
  ROLE_AGENCY_ADMIN = 'role_agency_admin',
  ROLE_AGENT_SUPERVISOR = 'role_agent_supervisor',
  ROLE_AGENCY_SUPERVISOR = 'role_agency_supervisor',
  ROLE_AGENT = 'role_agent',
  ROLE_AGENCY_AGENT = 'role_agency_agent',

  // Tenant roles
  ROLE_SUPER_USER = 'role_super',
  ROLE_TENANT_ADMIN = 'role_tenant_admin',
  ROLE_TENANT_ACCOUNTANT = 'role_tenant_accountant',
  ROLE_TENANT_OPR = 'role_operation',
  ROLE_INVENTORY_ADMIN = 'role_inventory',
  ROLE_TENANT_SALE = 'role_sales',
  ROLE_HOTEL_ADMIN = 'role_hotel_admin',
  ROLE_HOTEL_CHAIN_ADMIN = 'role_hotel_chain_admin',
  ROLE_GROUP_ADMIN = 'role_group_admin',
  // Permissions
  PERMISSION_ALL_ORDERS = 'all_orders',
  // PERMISSION_ALL_ORDERS = 'permission_all_orders',
  UPDATE_OP = 'update_op',
  ROLE_SUPPORT_TICKETING = "read_support_ticket",

}
